import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LandingPage.css';
import { LOGO, LOGO_SRCSET } from '../lib/imagenes';


const TESTIMONIOS = [
  { nombre: 'Valentina y Matías', dept: 'Capital', texto: 'Nos conocimos acá en marzo. En abril tomamos el primer mate juntos en el Parque de Mayo. Hoy vivimos juntos.', emoji: '💕' },
  { nombre: 'Sofía y Nicolás', dept: 'Rivadavia', texto: 'Yo nunca había usado una app de citas. Él me convenció con el primer mensaje. Ahora no me imagino sin él.', emoji: '❤️' },
  { nombre: 'Camila y Santiago', dept: 'Chimbas', texto: 'Nos dimos me gusta el mismo día. Charlamos tres semanas antes de vernos. Cuando nos vimos, ya nos conocíamos de verdad.', emoji: '✨' },
];

const FRASES_ROTATIVAS = [
  '¿Sabés qué tienen en común todas las parejas? Que en algún momento uno de los dos se animó primero.',
  'El amor no aparece cuando estás listo/a. Aparece cuando te animás a buscarlo.',
  'San Juan es chico, pero el amor siempre encuentra la manera.',
  'No existe el momento perfecto para buscar amor. Existe el momento en que te animás.',
  'Las mejores historias de amor empiezan cuando alguien decide mostrarse tal cual es.',
];

// Promo de lanzamiento: contador de lugares Premium para los primeros perfiles completos
function PromoFundadores({ onClick }) {
  const [promo, setPromo] = useState(null);
  useEffect(() => {
    fetch('/api/promo/fundadores', { cache: 'no-store' })
      .then(r => r.json()).then(setPromo).catch(() => {});
  }, []);
  if (!promo || !promo.activa) return null;
  const pct = Math.round((promo.otorgados / promo.total) * 100);
  return (
    <button type="button" className="promo-fundadores fade-up" onClick={onClick}>
      <div className="promo-fundadores-top">
        <span className="promo-fundadores-fuego">🔥</span>
        <span>Quedan <strong>{promo.restantes}</strong> lugares Premium gratis</span>
      </div>
      <div className="promo-fundadores-bar"><span style={{ width: `${pct}%` }} /></div>
      <div className="promo-fundadores-sub">
        Los primeros {promo.total} perfiles completos tienen {promo.dias} días de Premium 👑
      </div>
    </button>
  );
}

export default function LandingPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ usuarios: 47, matches: 23, ciudades: 19 });
  const [fraseIdx, setFraseIdx] = useState(0);
  const [testiIdx, setTestiIdx] = useState(0);

  useEffect(() => {
    fetch('/api/motivational/stats/public')
      .then(r => r.json())
      .then(d => setStats(d))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const t = setInterval(() => setFraseIdx(i => (i + 1) % FRASES_ROTATIVAS.length), 4000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    const t = setInterval(() => setTestiIdx(i => (i + 1) % TESTIMONIOS.length), 5000);
    return () => clearInterval(t);
  }, []);

  const features = [
    { icon: '🔒', title: 'Registro seguro', desc: 'Verificación por correo, contraseñas cifradas y sesiones protegidas. Tu privacidad es lo primero.' },
    { icon: '📍', title: 'Solo San Juan', desc: 'Filtrá por departamento. Capital, Rivadavia, Santa Lucía, Chimbas… acá te encontrás cerca.' },
    { icon: '🧉', title: 'Intereses reales', desc: 'Mate, peñas, montañismo, fútbol, vino. Conexiones por afinidad genuina, no solo por foto.' },
    { icon: '💘', title: 'Deslizá y conectá', desc: 'Deslizá para dar me gusta. Si les gustás también, ¡hay conexión! Recién ahí se abre el chat privado.' },
    { icon: '💬', title: 'Chat protegido', desc: 'Mensajería real, solo entre conexiones. Reportá lo que no corresponda con un toque.' },
    { icon: '🤖', title: 'Moderación activa', desc: 'Detección automática de contenido inapropiado. La comunidad se mantiene sana sola.' },
  ];

  const t = TESTIMONIOS[testiIdx];

  return (
    <div className="landing">
      <header className="landing-header">
        <div className="landing-nav container">
          <div className="landing-brand">
            <img src={LOGO} alt="Cupido con Mate" srcSet={LOGO_SRCSET} sizes="48px" className="landing-brand-logo" />
            <span className="landing-brand-text">Cupido con Mate San Juan</span>
          </div>
          <div className="landing-nav-actions">
            <button className="btn btn-ghost btn-sm" onClick={() => navigate('/auth')}>Ingresar</button>
            <button className="btn btn-primary btn-sm" onClick={() => navigate('/auth?mode=signup')}>Crear cuenta</button>
          </div>
        </div>

        <div className="hero container">
          <div className="hero-badge fade-up">
            <span>🌟</span> Hecho en San Juan, para sanjuaninos
          </div>
          <PromoFundadores onClick={() => navigate('/auth?mode=signup')} />
          <img src={LOGO} alt="Cupido con Mate" srcSet={LOGO_SRCSET} sizes="(max-width: 768px) 100px, 140px" className="hero-logo fade-up fade-up-1" />
          <h1 className="hero-title fade-up fade-up-2">
            Encontrá a tu<br />
            <span className="hero-title-rojo">media naranja,</span><br />
            <span className="hero-title-dorado">con un mate de por medio.</span>
          </h1>

          {/* FRASE MOTIVACIONAL ROTATIVA */}
          <div className="hero-frase fade-up fade-up-2">
            <span className="frase-comillas">"</span>
            <span className="frase-texto">{FRASES_ROTATIVAS[fraseIdx]}</span>
            <span className="frase-comillas">"</span>
          </div>

          <p className="hero-subtitle fade-up fade-up-3">
            La primera app de citas pensada para San Juan. Perfiles reales,
            intereses en común y chat solo cuando el gusto es mutuo.
          </p>
          <div className="hero-actions fade-up fade-up-4">
            <button className="btn btn-primary btn-lg" onClick={() => navigate('/auth?mode=signup')}>
              💘 Crear mi perfil gratis
            </button>
            <button className="btn btn-ghost btn-lg" onClick={() => navigate('/auth')}>
              Ya tengo cuenta
            </button>
          </div>
          <div className="hero-trust fade-up fade-up-4">
            <span>✅ Verificación por correo</span>
            <span>🔐 100% seguro</span>
            <span>🆓 Gratis para empezar</span>
          </div>
        </div>
      </header>

      {/* STATS DINÁMICOS */}
      <section className="stats-section">
        <div className="container stats-grid">
          <div className="stat-item">
            <span className="stat-num">{stats.usuarios}+</span>
            <div className="stat-label">Sanjuaninos registrados</div>
          </div>
          <div className="stat-item">
            <span className="stat-num">{stats.matches}+</span>
            <div className="stat-label">Conexiones reales</div>
          </div>
          <div className="stat-item">
            <span className="stat-num">{stats.ciudades}</span>
            <div className="stat-label">Departamentos activos</div>
          </div>
        </div>
      </section>

      {/* TESTIMONIO ROTATIVO */}
      <section className="testimonio-section container">
        <div className="testimonio-card" key={testiIdx}>
          <div className="testimonio-emoji">{t.emoji}</div>
          <p className="testimonio-autor">Así puede empezar tu historia</p>
          <p className="testimonio-texto">"{t.texto}"</p>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features container">
        <div className="section-eyebrow">¿Por qué Cupido con Mate?</div>
        <h2 className="section-title">Citas seguras, locales y con onda sanjuanina</h2>
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FRASE MOTIVACIONAL CENTRAL */}
      <section className="motivacion-section container">
        <div className="motivacion-inner">
          <img src={LOGO} alt="Cupido con Mate" srcSet={LOGO_SRCSET} sizes="80px" className="motivacion-logo" />
          <h2 className="motivacion-title">¿Y si hoy es el día?</h2>
          <p className="motivacion-sub">
            El 73% de los usuarios que completan su perfil hacen su primera conexión en menos de 48 horas.
            Solo hace falta animarse.
          </p>
          <div className="motivacion-pasos">
            <div className="paso">
              <div className="paso-num">1</div>
              <div className="paso-texto">Creás tu perfil en 5 minutos</div>
            </div>
            <div className="paso-flecha">→</div>
            <div className="paso">
              <div className="paso-num">2</div>
              <div className="paso-texto">Explorás perfiles de tu zona</div>
            </div>
            <div className="paso-flecha">→</div>
            <div className="paso">
              <div className="paso-num">3</div>
              <div className="paso-texto">Cuando el gusto es mutuo, charlan</div>
            </div>
          </div>
          <button className="btn btn-dorado btn-lg" onClick={() => navigate('/auth?mode=signup')}>
            Empezar ahora — es gratis 🚀
          </button>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="cta-section">
        <div className="container cta-inner">
          <img src={LOGO} alt="Logo" srcSet={LOGO_SRCSET} sizes="120px" className="cta-logo" />
          <h2 className="cta-title">Tu próxima historia empieza con un mate.</h2>
          <p className="cta-sub">Sumate gratis, completá tu perfil y empezá a conocer gente de tu zona en minutos.</p>
          <button className="btn btn-dorado btn-lg" onClick={() => navigate('/auth?mode=signup')}>
            Quiero conocer gente 🧉
          </button>
        </div>
      </section>

      <footer className="landing-footer">
        <p>© 2026 Cupido con Mate · San Juan, Argentina · Todos los derechos reservados</p>
        <p><a href="/ayuda" style={{ color: "inherit" }}>❓ Centro de ayuda</a></p>
      </footer>
    </div>
  );
}
